module.exports = __webpack_public_path__ + "static/media/CURSO.42bb0bef.png";